import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-compass",
  "use": "icon-compass-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-compass\"><circle cx=\"12\" cy=\"12\" r=\"9.2\" stroke=\"currentColor\" stroke-width=\"1.3\" /><path d=\"m15.5 8.5-2.2 4.8-4.8 2.2 2.2-4.8z\" fill=\"currentColor\" /><circle cx=\"12\" cy=\"12\" r=\"1\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol